<div class="container min-vh-100 d-flex align-items-center">
	<div class="row">
		<div class="col-md-7 justify-content-center align-items-end">
			<img src="assets/images/messge.png" class="img-fluid">
		</div>
		<div class="col-md-5 d-flex flex-column justify-content-center">
			<div class="text-center mb-2">
				<img src="assets/images/tick.png" class="img-fluid check-img">
			</div>
			<h2 class="create-account text-center">Your Password</h2>
			<h2 class="create-account text-center">Successfully Changed</h2>
			<p class="sub-head">Sign in to your account with your new password</p>
			<div class="col-md-10 offset-md-1 mb-3 text-center">
				<a href="/login" class="btn-signup">Login</a>
			</div>
		</div>

	</div>
</div>